// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-item {
  height: 68px;
  position: relative;
  background: rgba(255, 120, 125, 0.4);
  border-radius: 100px;
  width: 100%;
  margin-bottom: 15px;
}
.section-item .in {
  position: absolute;
  height: 46px;
  width: 45px;
  left: 15px;
  top: 11px;
  border-radius: 50%;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px rgba(255, 120, 125, 0.25);
  color: #FF787D;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  line-height: 47px;
}
.section-item .section-name {
  position: absolute;
  color: white;
  height: 100%;
  padding-top: 14px;
  left: 80px;
  font-size: 20px;
  font-weight: bold;
}
.section-item .action-buttons {
  position: absolute;
  right: 19px;
  top: 18px;
}
.section-item .action-buttons .action-button {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: white;
  display: inline-block;
  margin-left: 7px;
  text-align: center;
  line-height: 47px;
  cursor: pointer;
}
.section-item .action-buttons .action-button mat-icon {
  color: #FF787D;
}

input {
  background: none;
  width: 534.56px;
  height: 40.31px;
  border-radius: 20px !important;
  padding-left: 15px !important;
  color: white;
}
input:enabled {
  background: rgba(255, 255, 255, 0.7);
  color: #FF787D;
}`, "",{"version":3,"sources":["webpack://./src/app/@modules/research-sheet/core/research-template/section-choice-item/section-choice-item.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,kBAAA;EAEA,oCAAA;EACA,oBAAA;EACA,WAAA;EAEA,mBAAA;AADF;AAGE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,kDAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AADJ;AAIE;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AAFJ;AAKE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAHJ;AAKI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAHN;AAKM;EACE,cAAA;AAHR;;AASA;EACE,gBAAA;EACA,eAAA;EACA,eAAA;EACA,8BAAA;EACA,6BAAA;EACA,YAAA;AANF;AAQE;EACE,oCAAA;EACA,cAAA;AANJ","sourcesContent":[".section-item {\n  height: 68px;\n  position: relative;\n\n  background: rgba(255, 120, 125, 0.4);\n  border-radius: 100px;\n  width: 100%;\n\n  margin-bottom: 15px;\n\n  .in {\n    position: absolute;\n    height: 46px;\n    width: 45px;\n    left: 15px;\n    top: 11px;\n    border-radius: 50%;\n    background: #FFFFFF;\n    box-shadow: 0px 0px 10px rgba(255, 120, 125, 0.25);\n    color: #FF787D;\n    font-size: 16px;\n    font-weight: bold;\n    text-align: center;\n    line-height: 47px;\n  }\n\n  .section-name {\n    position: absolute;\n    color: white;\n    height: 100%;\n    padding-top: 14px;\n    left: 80px;\n    font-size: 20px;\n    font-weight: bold;\n  }\n\n  .action-buttons {\n    position: absolute;\n    right: 19px;\n    top: 18px;\n\n    .action-button {\n      width: 32px;\n      height: 32px;\n      border-radius: 50%;\n      background: white;\n      display: inline-block;\n      margin-left: 7px;\n      text-align: center;\n      line-height: 47px;\n      cursor: pointer;\n\n      mat-icon {\n        color: #FF787D;\n      }\n    }\n  }\n}\n\ninput {\n  background: none;\n  width: 534.56px;\n  height: 40.31px;\n  border-radius: 20px !important;\n  padding-left: 15px !important;\n  color: white;\n\n  &:enabled {\n    background: rgba(255, 255, 255, 0.7);\n    color: #FF787D;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
